export const allFeedbackParamsSelector = (state) => state.feedback.params;
export const allFeedbackSelector = (state) => state.feedback;
